export default "__VITE_ASSET__Dv2j9r2s__"